import { IThreeVariantXP } from '@faire/web-api--source/indigofair/settings/IThreeVariantXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls whether or not we render the perf app for the SEM discover page
 */
export const NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB =
  'NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB' as SettingConst<
    'NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB',
    keyof typeof IThreeVariantXP.Bucket,
    'RETAILER' | 'RETAILER_HEAD_TAGS' | 'VISITOR_WEB' | 'VISITOR_WEB_HEAD_TAGS'
  >;
